<template>
	<Modal headline="Fejl" :visible="visible" @close="hide()">
		<p>Der skete desværre en fejl, mens du var i gang med din tilmelding. Din kurv er tom, og du må starte forfra.</p>
	</Modal>
</template>

<script>
export default {
	computed: {
		visible: function() {
			return this.$store.getters.basketClearedByError;
		}
	},
	methods: {
		hide: function() {
			return this.$store.dispatch("hideBasketClearedByError");
		}
	}
}
</script>
